// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

/**
 * Skeleton loading state for the exchange order table.
 */
export function ExchangeOrderTableSkeleton() {
  return (
    <TableContainer component={Paper} variant="outlined">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width="25%">References</TableCell>
            <TableCell width="25%">From/To location</TableCell>
            <TableCell width="30%">Items</TableCell>
            <TableCell width="20%">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[1, 2, 3, 4, 5].map((row) => (
            <TableRow key={row}>
              <TableCell>
                <Skeleton variant="text" width="80%" />
                <Skeleton variant="text" width="60%" />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="70%" />
                <Skeleton variant="text" width="70%" />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="90%" />
                <Skeleton variant="text" width="85%" />
              </TableCell>
              <TableCell>
                <Skeleton variant="rectangular" width={80} height={24} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
